import { useEffect, useRef, useState } from 'react';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';

export const tooltipDisplayTime = 4000;
export const tooltipFadeTime = 200;
export const tooltipFadeTimeShow = 50;

export const useUnfollowTooltip = (isFollowing?: boolean) => {
  const [showUnfollowTooltip, setShowUnfollowTooltip] = useState(false);
  const [isFollowingState, setIsFollowingState] = useState<boolean | undefined>();
  const [isHidingTooltip, setIsHidingTooltip] = useState(false);
  const { isSmallScreen } = useScreenContext();

  const hideRef = useRef<number>();
  const showRef = useRef<number>();
  const tooltipRef = useRef<number>();

  useEffect(() => {
    setIsFollowingState(isFollowing);
    if (isFollowingState === true && isFollowing === false && !isHidingTooltip) {
      setShowUnfollowTooltip(true);
      showRef.current = window.setTimeout(() => {
        setIsHidingTooltip(true);
      }, tooltipFadeTimeShow);
      hideRef.current = window.setTimeout(() => {
        setIsHidingTooltip(false);
      }, tooltipDisplayTime);
      tooltipRef.current = window.setTimeout(() => {
        setShowUnfollowTooltip(false);
      }, tooltipDisplayTime + tooltipFadeTime);
    }
  }, [isFollowing, isFollowingState, isHidingTooltip]);

  useEffect(() => {
    return () => {
      clearTimeout(hideRef.current);
      clearTimeout(showRef.current);
      clearTimeout(tooltipRef.current);
    };
  }, []);

  const baseContainerStyle = {
    opacity: isHidingTooltip ? '1' : '0',
    transition: `opacity ${tooltipFadeTime / 1000}s`,
  };

  const containerStyle = {
    ...baseContainerStyle,
    ...(isSmallScreen
      ? {
          transform: 'translate(0)',
          bottom: '24px',
          top: 'unset',
          left: '0',
          right: '0',
          width: '100vw',
          position: 'fixed',
        }
      : {}),
  };

  return {
    isSmallScreen,
    isOpen: showUnfollowTooltip,
    showUnfollowTooltip,
    containerStyle,
    ...(isSmallScreen ? { contentLocation: { top: 0, left: 0 } } : {}),
    ...(isSmallScreen ? { tooltipMaxWidth: '100vw' } : {}),
  };
};
